export default __webpack_public_path__ + "static/media/tour-access-lock-failed.d00499e6.svg";